import React, { Component } from 'react';
import './App.css';

class HeroImage extends Component{
  render(){
    return(
      <section className='heroImage'>
        <h5 className="nopad nomargin"></h5>
      </section>
    )
  }
}
export default HeroImage;



// WEBPACK FOOTER //
// ./src/heroImage.js